import { FC } from 'react';
import { IconProps } from '../../types';

export const Final1: FC<IconProps> = ({ width = 15, height = 15, ...props }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M0 7.5C0 3.35786 3.35786 0 7.5 0C11.6421 0 15 3.35786 15 7.5C15 11.6421 11.6421 15 7.5 15C3.35786 15 0 11.6421 0 7.5Z"
        fill="url(#paint0_linear_6141_57924)"
      />
      <path
        d="M4.15191 3.552H7.28391V4.584H5.37591V7.152H7.10391V8.148H5.37591V11.988H4.15191V3.552ZM8.544 3.588H10.44V11.988H9.252V4.608H8.544V3.588Z"
        fill="#4D4119"
      />
      <defs>
        <linearGradient
          id="paint0_linear_6141_57924"
          x1="7.52459"
          y1="0"
          x2="7.52459"
          y2="15"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFF3D1" />
          <stop offset="0.19" stopColor="#D9B446" />
          <stop offset="0.335" stopColor="#DDBE63" />
          <stop offset="0.48" stopColor="#E1C266" />
          <stop offset="0.63" stopColor="#FFEEB5" />
          <stop offset="0.785" stopColor="#F1D277" />
          <stop offset="0.89" stopColor="#DCBB5B" />
          <stop offset="1" stopColor="#FFF2CA" />
        </linearGradient>
      </defs>
    </svg>
  );
};
